export function statusName (status) {
  status = Number(status) || status
  switch (status) {
  case (1):
    return {color: '#f50', text: '待处理'}
  case (2):
    return {color: '#2db7f5', text: '退货中'}
  case (4):
    return {color: '#87d068', text: '已完成 '}
  case (3):
    return {color: '#108ee9', text: '已拒绝'}
  case ('总数'):
  default:
    return {color: '#108ee9', text: '全部'}
  }
}

export const getStatus = status => {
  switch (status) {
  case 11:
    return '未支付'
  case 12: 
    return '用户已取消'
  case 13: 
    return '超时已取消'
  case 21: 
    return '商家未发货'
  case 31: 
    return '商家已发货'
  case 41:
  case 42:
    return '已收货'
  case 51:
    return '申请退款'
  case 52:
    return '退款成功'
  case 61:
  case 62:
    return '已完成'
  default: 
    return '退款失败'
  }
}